import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { Link } from "@quintype/components";
import ResponsiveImageWithFallback from "../responsive-image-with-fallback";

import { isPremium } from "../../../../isomorphic/data/story";

import styles from "./styles.m.css";
import { getStoryData, generateImageSources, checkAppSlug, pdfIssueDateFormat } from "../../utils/utils";
import Icon from "../icon";

const DigitalEbookStoryCard = ({
  story,
  cardWithImageZoom = true,
  className = "",
  hasTruncatedHeadline = true,
  bigimage = true,
  pFrom = "big-card",
  iconbottomright = false,
  videocard = false,
  onClickEbookOffer
}) => {
  const [userType, setUserType] = useState("F");

  useEffect(() => {
    if (global && global.userPromise) {
      global.userPromise.catch(() => ({})).then(user => {
        if (user && user.userType) {
          setUserType(user.userType);
        }
      });
    }
  }, []);

  const storyData = {
    ...getStoryData(story, false),
    firstPublishedAt: pdfIssueDateFormat(get(story, ["first-published-at"], ""), "relative")
  };
  const externalLink = get(story, ["metadata", "reference-url"]);
  const checkSlug = checkAppSlug();
  let SourceLink = "";
  const price = get(story, ["metadata", "story-attributes", "actualprice", 0]);
  const description = get(story, ["cards", 0, "story-elements", 0, "text"], "E book").replace(/<[^>]*>/g, "");
  const amazonurl = get(story, ["metadata", "story-attributes", "amazonurl", 0]);

  if (checkSlug) {
    SourceLink = externalLink || story.url;
  }

  if (!storyData.headline) {
    return null;
  }

  const icons = {
    "photo-album": "",
    photo: "",
    video: "video-play"
  };
  const iconType = get(icons, [story["story-template"]], null);

  return (
    <div
      className={`${className} ${styles["read-more-link"]} ${
        videocard ? styles["hasvideobigcard"] : styles["hasnotvideobigcard"]
      }`}
    >
      <div
        className={`${styles["base"]} ${bigimage ? styles["fullheightimage"] : ""} ${
          iconbottomright ? styles["hasicon"] : styles["hasnoticon"]
        }`}
      >
        <div className={styles["image-with-icon"]}>
          <ResponsiveImageWithFallback
            className={styles["image-wrapper"]}
            slug={storyData.imageS3Key}
            metadata={storyData.imageMetadata}
            isPremium={isPremium(story)}
            alt={storyData.imageCaption}
            imgParams={{ auto: ["format", "compress"] }}
            sources={generateImageSources(
              { aspectRatio: [3, 4], screenWidthCoverage: 0 },
              { aspectRatio: [3, 4], screenWidthCoverage: 0.25 }
            )}
            story={story}
          />
          {iconbottomright &&
            iconType && (
              <span className={styles["story-template-icon"]}>
                <Icon type={iconType} className={styles["template-icon"]} />
              </span>
            )}
        </div>
        <div className={styles["digital-ebook-details"]}>
          <div className={styles["meta-row"]}>
            <div className={styles["story-date"]}>{storyData.firstPublishedAt}</div>
            <div className={styles["card-price-pill"]}>₹{price || "499"}</div>
          </div>
          <Link
            aria-label={`${"Read full story: "} ${storyData.headline}`}
            className={styles["text-wrapper"]}
            href={`${amazonurl}`}
            externalLink={SourceLink || externalLink}
          >
            <h3 className={`${styles["headline"]} ${hasTruncatedHeadline ? styles["truncated"] : ""} `}>
              {description
                ? description.length > 200
                  ? `${description.slice(0, 200)}...`
                  : description
                : storyData.headline}
            </h3>
          </Link>

          <div className={styles["links-footer"]}>
            <Link className={styles["footer-link"]} href="#" />
            {userType === "P" || userType === "T" || userType === "R" ? (
              <Link className={styles["footer-link-red"]} href={"https://onelink.to/cm4vtj"}>
                Read in app
              </Link>
            ) : (
              <Link className={styles["footer-link-red"]} href={amazonurl}>
                Buy e-book
              </Link>
            )}
          </div>

          {userType !== "P" &&
            userType !== "T" &&
            userType !== "R" && (
              <div
                className={styles["offer-box"]}
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  onClickEbookOffer();
                }}
              >
                <div className={styles["offer-text"]}>₹10,000 மதிப்பிலான விகடன் டிஜிட்டல் புத்தகங்கள்.</div>
                <button className={styles["subscribe-btn"]}>Subscribe</button>
              </div>
            )}
        </div>
      </div>
    </div>
  );
};

DigitalEbookStoryCard.propTypes = {
  cardWithImageZoom: PropTypes.bool,
  className: PropTypes.string,
  hasTruncatedHeadline: PropTypes.bool,
  bigimage: PropTypes.bool,
  story: PropTypes.shape({
    id: PropTypes.string,
    authors: PropTypes.arrayOf(
      PropTypes.shape({
        "contributor-role": PropTypes.shape({
          name: PropTypes.string
        }),
        name: PropTypes.string
      })
    ),
    headline: PropTypes.string.isRequired,
    metadata: PropTypes.shape({
      "reference-url": PropTypes.string
    }),
    alternative: PropTypes.shape({
      home: PropTypes.shape({
        default: PropTypes.shape({
          headline: PropTypes.string
        })
      })
    }),
    slug: PropTypes.string.isRequired,
    "hero-image-metadata": PropTypes.shape({
      height: PropTypes.number,
      width: PropTypes.number,
      "aspect-ratio": PropTypes.arrayOf(PropTypes.number)
    }),
    "hero-image-s3-key": PropTypes.string,
    "hero-image-caption": PropTypes.string
  }),
  pFrom: PropTypes.string,
  iconbottomright: PropTypes.bool,
  videocard: PropTypes.bool,
  onClickEbookOffer: PropTypes.func
};

export default DigitalEbookStoryCard;
